import React from "react"
import { useTheme } from "@mui/material/styles"
import chroma from "chroma-js"

import styled from "styled-components"

const CrosshairSeriesWrap = styled.div<{
  backgroundColor: string
  width: number | string
}>`
  padding: 0.5rem;
  margin: 0 1rem;
  background: ${p => p.backgroundColor};
  width: ${p => p.width};
`

const SeriesRow = styled.div`
  display: grid;
  grid-template-columns: 40% 60%;
  margin: 1px 0;
  white-space: nowrap;

  > label {
    margin-right: 3px;
    text-align: left;
  }

  > span {
    text-align: right;
  }
`

type TCrosshairXY = {
  x: number
  y: number
}
type TCrosshairValueFormatter = ({ x, y }: TCrosshairXY) => string

const defaultValueFormatter: TCrosshairValueFormatter = v => `${v.y}`

interface ICrosshairSeries {
  colors: string[]
  seriesTitles: string[]
  values: TCrosshairXY[]
  valueFormatter: TCrosshairValueFormatter
  width: string | number
}

const CrosshairSeries = ({
  colors,
  seriesTitles,
  values,
  valueFormatter,
  width = "auto"
}: ICrosshairSeries) => {
  const theme = useTheme()
  const seriesValueFormatter =
    typeof valueFormatter === "function"
      ? valueFormatter
      : defaultValueFormatter

  return (
    <CrosshairSeriesWrap
      backgroundColor={chroma(theme.basePalette.bg).alpha(0.6).css()}
      width={width}
    >
      {seriesTitles.map((title, i) => (
        <SeriesRow key={`crosshair-series${i}`}>
          <label style={{ color: colors[i] }}>{title}:</label>
          <span style={{ color: theme.palette.text.primary }}>
            {values && values[i] ? seriesValueFormatter(values[i]) : "-"}
          </span>
        </SeriesRow>
      ))}
    </CrosshairSeriesWrap>
  )
}

export default CrosshairSeries
